import { Component, Inject } from '@angular/core';
import { InternalEquipmentPerformances } from '../../../../model/internalEquipmentPerformances';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { ThemeService } from '../../../../services/theme.service';
import { SnackBarService } from '../../../../services/snackBar.service';
import { TranslateService } from '@ngx-translate/core';
import { MatCheckboxChange } from '@angular/material/checkbox';

export interface DialogDataInternalEquipmentEditPerformances {
  performances: InternalEquipmentPerformances[],
  idStatus: number
}

@Component({
  selector: 'app-internal-equipment-edit-select-performances',
  templateUrl: './internal-equipment-edit-select-performances.component.html',
  styleUrl: './internal-equipment-edit-select-performances.component.scss',
  standalone: false
})
export class InternalEquipmentEditSelectPerformancesComponent {
  constructor(@Inject(MAT_DIALOG_DATA) public data: DialogDataInternalEquipmentEditPerformances,
  public dialogRef: MatDialogRef<InternalEquipmentEditSelectPerformancesComponent>,
  public dialog: MatDialog,
  public snackBarService: SnackBarService,
  private translate: TranslateService) { }

  onPerformanceSelectChange(idActionType: number, event: MatCheckboxChange): void {
    let performance = this.data.performances.find(eq => eq.idActionType === idActionType);
    performance.checkSelected = event.checked;
  }

  showPerformances(idActionType: number): string {
    return  idActionType === 1 ? this.translate.instant('internalEquipmentActions.calibration'):
            idActionType === 2 ? this.translate.instant('internalEquipmentActions.verification') :
            idActionType === 3 ? this.translate.instant('internalEquipmentActions.maintenance'):
            idActionType === 4 ? this.translate.instant('internalEquipmentActions.qualification') :
            idActionType === 5 ? this.translate.instant('internalEquipmentActions.characterization'): '-';
  }

  onOkClick() {
    const valid = this.data.performances.some(eq => eq.checkSelected);
     if (valid) {
      this.dialogRef.close(this.data.performances);
     } else {
       this.snackBarService.sendError(this.translate.instant('internalEquipment.dialog.performance.status.error'));
     }
  }

  onNoClick() {
    this.dialogRef.close(null);
  }
}
